import createReportFiltersetFn from "ApiLayer/Measures/queryCreateReportFilterset";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation } from "react-query";
import useFiltersetState from "recoilStore/Filters/useFilterset";
import useFilters from "recoilStore/useFilters";
import { showMutationAlert } from "utils/helpers";

export const useCreateReportFilterset = () => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const { filters } = useFilters();
    const { state: filtersetState, setState: setFiltersetState, resetState: resetFiltersetState } = useFiltersetState();

    const filtersWithPublished = {
        ...filters,
        booleanFilters: [...filters.booleanFilters, { condition: "TRUE", field: "is_published" } as BooleanFilter],
    };

    const filtersWithReported = {
        ...filters,
        booleanFilters: [...filters.booleanFilters, { condition: "TRUE", field: "is_reported" } as BooleanFilter],
    };

    return useMutation({
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        onSuccess: (data) => {
            if (data.reportedFilterset && data.publishedFilterset) {
                setFiltersetState({
                    ...filtersetState,
                    reportsPagePublishedFilterset: data.publishedFilterset,
                    reportsPageReportedFilterset: data.reportedFilterset,
                });
            } else {
                alert.error("Failed to create report filterset");
            }
        },
        mutationFn: async () => {
            resetFiltersetState();
            const reportedFilterset = await createReportFiltersetFn(accessToken, filtersWithReported);
            const publishedFilterset = await createReportFiltersetFn(accessToken, filtersWithPublished);
            return {
                reportedFilterset: reportedFilterset.createReportFilterset,
                publishedFilterset: publishedFilterset.createReportFilterset,
            };
        },
    });
};
